import { Select } from "antd";
import { getOrderRequirementTypes } from "api/coreapi/orders";
import { useEffect, useState } from "react";
import { EnumTypeModel } from "shared/models/enumTypeModel";

interface OrderRequirementSelectProps {
    value?: number;
    mode?: 'multiple' | 'tags' | undefined;
    style?: React.CSSProperties | undefined;
    onChange?: (value?: number) => void;
}

const OrderRequirementSelect: React.FC<OrderRequirementSelectProps> = (props) => {
    const {
        value,
        mode,
        style,
        onChange        
    } = props;
    
    var [types, setTypes] = useState<EnumTypeModel[]>();
    const triggerChange = (changedValue?: number) => {
        onChange?.(changedValue);
      };

      const onSelectedItemChange = (newType: number) => {
        triggerChange(newType);
      };

    useEffect(() => {

        const getInfo = async () => {
            try {
                const res = await getOrderRequirementTypes();
                setTypes(res.result);
            } catch (error: any) {
            }
        };

        getInfo();
    }, []);


    return (
        <Select
            style={ style }
            mode={mode}
            defaultValue={value}
            onChange={onSelectedItemChange}
            options={types?.map((item) => ({
                value: item.id.toString(),
                label: item.displayName ?? item.name,
            }))}
        />

    );
}

export default OrderRequirementSelect;